import { commonViewTexts } from '../common';

export const notFoundPageViewTexts = {
  title: 'ページが見つかりませんでした。',
  goToKoumutenList: `${commonViewTexts.koumuten}一覧へ移動`,
  goToLogin: 'ログイン画面へ移動'
} as const;
